const ActionTypes = {
  FETCH_DATA: 'FETCH_DATA',
  FETCH_DATA_ERROR: 'FETCH_DATA_ERROR',
  FETCH_DATA_LOADING: 'FETCH_DATA_LOADING',
  SORT_DATA: 'SORT_DATA',
  VIEW_COUNTRY_DETAILS: 'VIEW_COUNTRY_DETAILS',
  VIEW_COUNTRY_DETAILS_LOADIND: 'VIEW_COUNTRY_DETAILS_LOADIND',
};
export default ActionTypes;
